const typesOptions = [
	{ key: "quick_reply", text: "Respuesta Rápida", value: "Respuesta Rápida" },
	{ key: "url", text: "URL", value: "URL" },
	{ key: "phone_number", text: "Teléfono", value: "Teléfono" },
	{ key: "copy_code", text: "Copiar Código", value: "Copiar Código" },
];

export default typesOptions;
